var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54237 3.67798C3.68784 3.67798 3 4.36581 3 5.22035V15.3898C3 16.2443 3.68787 16.9322 4.54237 16.9322H10.3051C10.8574 16.9322 11.3051 17.3799 11.3051 17.9322C11.3051 18.4845 10.8574 18.9322 10.3051 18.9322H4.54237C2.58323 18.9322 1 17.3488 1 15.3898V5.22035C1 3.26124 2.58327 1.67798 4.54237 1.67798H19.4576C21.4167 1.67798 23 3.26124 23 5.22035V15.3898C23 17.3488 21.4168 18.9322 19.4576 18.9322H18.0847V21.322C18.0847 21.7265 17.8411 22.0911 17.4674 22.2459C17.0938 22.4007 16.6636 22.3152 16.3776 22.0292L12.9878 18.6393C12.5973 18.2488 12.5973 17.6156 12.9878 17.2251C13.3783 16.8346 14.0115 16.8346 14.402 17.2251L16.0847 18.9078V17.9322C16.0847 17.3799 16.5325 16.9322 17.0847 16.9322H19.4576C20.3121 16.9322 21 16.2443 21 15.3898V5.22035C21 4.36581 20.3122 3.67798 19.4576 3.67798H4.54237Z",
    fill: "#612AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.06781C12.5523 5.06781 13 5.51552 13 6.06781V14.5424C13 15.0947 12.5523 15.5424 12 15.5424C11.4477 15.5424 11 15.0947 11 14.5424V6.06781C11 5.51552 11.4477 5.06781 12 5.06781Z",
    fill: "#612AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61017 6.76272C9.16245 6.76272 9.61017 7.21044 9.61017 7.76272V12.8475C9.61017 13.3998 9.16245 13.8475 8.61017 13.8475C8.05788 13.8475 7.61017 13.3998 7.61017 12.8475V7.76272C7.61017 7.21044 8.05788 6.76272 8.61017 6.76272Z",
    fill: "#612AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3898 6.76272C15.9421 6.76272 16.3898 7.21044 16.3898 7.76272V12.8475C16.3898 13.3998 15.9421 13.8475 15.3898 13.8475C14.8375 13.8475 14.3898 13.3998 14.3898 12.8475V7.76272C14.3898 7.21044 14.8375 6.76272 15.3898 6.76272Z",
    fill: "#612AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22034 8.45764C5.77262 8.45764 6.22034 8.90535 6.22034 9.45764V11.1526C6.22034 11.7048 5.77262 12.1526 5.22034 12.1526C4.66805 12.1526 4.22034 11.7048 4.22034 11.1526V9.45764C4.22034 8.90535 4.66805 8.45764 5.22034 8.45764Z",
    fill: "#612AFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7797 8.45764C19.3319 8.45764 19.7797 8.90535 19.7797 9.45764V11.1526C19.7797 11.7048 19.3319 12.1526 18.7797 12.1526C18.2274 12.1526 17.7797 11.7048 17.7797 11.1526V9.45764C17.7797 8.90535 18.2274 8.45764 18.7797 8.45764Z",
    fill: "#612AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.19652eb7bc9285f2db888648c55eef13.svg";
export { ForwardRef as ReactComponent };